import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { useTranslation } from "react-i18next";

/**
 * OAuth Graph Callback Page
 *
 * This page is the redirect target for the Graph OAuth consent flow.
 * The Edge Function redirects here after processing the OAuth callback,
 * so that postMessage + window.close() work (same-origin as opener).
 *
 * This page does NOT require authentication (popup has no session).
 */
const OAuthGraphCallback = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const success = searchParams.get("success") === "true";
    const message = searchParams.get("message") || "";
    const tenantId = searchParams.get("tenant_id") || "";

    // Notify the opener window
    try {
      if (window.opener) {
        window.opener.postMessage(
          {
            type: "graph-oauth-complete",
            success,
            message,
            tenant_id: tenantId,
          },
          "*",
        );
      }
    } catch (e) {
      console.error("postMessage failed", e);
    }

    // Close the popup (works because same origin as opener)
    setTimeout(() => {
      window.close();
      // If window.close() didn't work, show fallback
      setTimeout(() => setShowFallback(true), 500);
    }, 300);
  }, [searchParams]);

  const success = searchParams.get("success") === "true";

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <div className="text-center space-y-3">
        {!showFallback ? (
          <p className="text-muted-foreground">
            {success
              ? t("auth.oauth.graphCallback.successClosing")
              : t("auth.oauth.graphCallback.errorClosing")}
          </p>
        ) : (
          <>
            <p className="text-foreground font-medium">
              {success
                ? t("auth.oauth.graphCallback.successMessage")
                : t("auth.oauth.graphCallback.errorMessage")}
            </p>
            <p className="text-sm text-muted-foreground">
              {t("auth.oauth.graphCallback.closeHint")}
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default OAuthGraphCallback;
